<template>
  <div class="IndexPageSidebarMenu" :class="{ isOpen }">
    <button class="menuToggleButton" v-html="dropdownCaretSvg" @click="toggleMenu" />
    <div class="heading menuClosedPlaceholder">{{ heading }}</div>
    <div class="menu">
      <h3 class="heading">{{ heading }}</h3>
      <ul class="items">
        <li v-for="item in items" :key="item.key" class="item">
          <button
            @click="item.doSelectCategory"
            :class="(selectedCategoryObj.value === item.category) && 'active'"
          >
            {{ item.text }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

import dropdownCaretSvg from '~/assets/ui/dropdown-caret.svg?raw'

const { heading, categories, selectedCategoryObj } = defineProps({
  heading: String,
  categories: Array,
  selectedCategoryObj: Object,
})

const isOpen = ref(false)

function toggleMenu() {
  isOpen.value = !isOpen.value
}

const items = categories.map(
  ({ title, slug }) => ({
    key: slug || 'ALL',
    text: title,
    category: slug,
    doSelectCategory() {
      selectedCategoryObj.value = slug
    },
  })
)
</script>

<style scoped>

.IndexPageSidebarMenu {
  border: 2px solid var(--hairline-color);
  border-radius: 10px;
  padding: var(--spacing-4) var(--spacing-8);
  position: relative;
  font-size: var(--font-size-2);
  line-height: 1.5;
}

.menuToggleButton {
  position: absolute;
  padding: var(--spacing-3);
  top: var(--spacing-2);
  right: var(--spacing-4);
  transition: transform 0.15s;
}

.IndexPageSidebarMenu:not(.isOpen) .menu {
  display: none;
}

.IndexPageSidebarMenu.isOpen .menuToggleButton {
  transform: scaleY(-1);
}

.IndexPageSidebarMenu.isOpen .menuClosedPlaceholder {
  display: none;
}

.heading {
  font-weight: 500;
  color: var(--text-color-black);
}

.heading + .items {
  margin-top: var(--spacing-1);
  border-top: thin solid var(--hairline-color);
}

.items {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.item {
  margin-top: var(--spacing-4);
  font-weight: 400;
  color: var(--text-color-dark);
  transition: color 0.15s;
}

.item:hover {
  color: var(--brand-color);
}

.item .active {
  font-weight: 600;
}

@media (--screen-lg) {

  .IndexPageSidebarMenu {
    border-style: none;
    padding: 0;
  }

  .menuToggleButton,
  .menuClosedPlaceholder {
    display: none;
  }

  .menu {
    display: block !important;
  }
}
</style>
